import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../utils/cn';
const variantClasses = {
    primary: 'bg-primary-100 text-primary-700 dark:bg-primary-900/30 dark:text-primary-300',
    secondary: 'bg-secondary-100 text-secondary-700 dark:bg-secondary-900/30 dark:text-secondary-300',
    success: 'bg-success-100 text-success-700 dark:bg-success-900/30 dark:text-success-300',
    danger: 'bg-danger-100 text-danger-700 dark:bg-danger-900/30 dark:text-danger-300',
    warning: 'bg-warning-100 text-warning-700 dark:bg-warning-900/30 dark:text-warning-300',
    info: 'bg-info-100 text-info-700 dark:bg-info-900/30 dark:text-info-300',
    dark: 'bg-dark-200 text-dark-700 dark:bg-dark-700 dark:text-dark-200',
    outline: 'bg-transparent border border-dark-300 text-dark-700 dark:border-dark-600 dark:text-dark-300',
};
const dotVariantClasses = {
    primary: 'bg-primary-500',
    secondary: 'bg-secondary-500',
    success: 'bg-success-500',
    danger: 'bg-danger-500',
    warning: 'bg-warning-500',
    info: 'bg-info-500',
    dark: 'bg-dark-500',
    outline: 'bg-dark-400',
};
const sizeClasses = {
    sm: 'text-xs px-1.5 py-0.5',
    md: 'text-xs px-2 py-0.5',
    lg: 'text-sm px-2.5 py-1',
};
export const Badge = forwardRef(({ variant = 'primary', size = 'md', dot, icon, children, className, ...props }, ref) => {
    return (_jsxs("span", { ref: ref, className: cn('inline-flex items-center gap-1 font-medium rounded-full whitespace-nowrap', variantClasses[variant], sizeClasses[size], className), ...props, children: [dot && (_jsx("span", { className: cn('h-1.5 w-1.5 rounded-full shrink-0', dotVariantClasses[variant]), "aria-hidden": "true" })), icon && (_jsx("span", { className: "inline-flex shrink-0", "aria-hidden": "true", children: icon })), children] }));
});
Badge.displayName = 'Badge';
//# sourceMappingURL=Badge.js.map